module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.choose
    }
  }, [_vm._t("default", [_vm._v("选择文件")])], 2), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "name": _vm.name,
      "disabled": _vm.disabled,
      "accept": _vm.accept,
      "multiple": _vm.multiple,
      "required": _vm.required
    },
    on: {
      "input": _vm.input,
      "change": _vm.change
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20530205!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/File.vue
// module id = 102
// module chunks = 2